var render = function render(){var _vm=this,_c=_vm._self._c;return _c('examples-block',{attrs:{"gitUrl":"src/components/examples/Table/TableFixedHeader.vue","title":"Таблица с фиксированной шапкой и цветом amelie"}},[_c('r-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"is-fixed-header":"","color-header":"amelie"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }